import { useCallback } from 'react'

import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { SubscriptionDetails, SubscriptionDetailValues } from 'organization/types'

export const usePutSubscriptionDetails = (): [
  (organizationId: number, payload: SubscriptionDetailValues) => Promise<SubscriptionDetails>,
  Status<SubscriptionDetails>,
] => {
  const [request, status] = useFetchRefactored<SubscriptionDetails>()

  const putSubDetails = useCallback(
    async (organizationId: number, payload: SubscriptionDetailValues) => {
      return request({
        method: 'put',
        url: `/organizations/${organizationId}/subscription_details`,
        config: {
          body: payload,
        },
      })
    },
    [request],
  )

  return [putSubDetails, status]
}
